import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { regions } from '@services/api'

export class regionsStore extends StoreExt {
    @observable list = []

    @action
    getRegions = async () => {
        const { data: list } = await regions.getList()
        runInAction(() => {
            this.list = list
        })
    }
}

export default remotedev(new regionsStore())
